import React from 'react';
import { Wrench } from 'lucide-react';

export function Skills() {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold flex items-center gap-2">
        <Wrench className="w-5 h-5" />
        Skills
      </h2>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Technical Skills
        </label>
        <textarea
          name="technical_skills"
          rows={3}
          placeholder="e.g., JavaScript, React, Node.js (separate with commas)"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 
            focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Soft Skills
        </label>
        <textarea
          name="soft_skills"
          rows={3}
          placeholder="e.g., Leadership, Communication, Problem Solving (separate with commas)"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 
            focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700">
          Languages
        </label>
        <textarea
          name="languages"
          rows={2}
          placeholder="e.g., English (Native), Spanish (Intermediate)"
          className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 
            focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
        />
      </div>
    </div>
  );
}